/* TheMindMarket theme — interactions (v1.1) */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var mb = e.target.closest('[data-menu-toggle]');
    if (mb) { var nav = document.getElementById('mobile-nav'); if (nav) nav.classList.toggle('open'); return; }
    var fq = e.target.closest('.faq > button');
    if (fq) { fq.parentElement.classList.toggle('open'); }
    var th = e.target.closest('[data-thumb]');
    if (th) {
      var main = document.getElementById('pg-main-img');
      if (main) { main.src = th.getAttribute('data-full'); }
      document.querySelectorAll('.pg-thumb').forEach(function (t) { t.classList.remove('active'); });
      th.classList.add('active');
    }
  });

  /* scroll reveal */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.classList.add('reveal-init'); io.observe(el); });
  }

  /* header scroll state */
  function initHeader() {
    var h = document.querySelector('.site-header');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('scrolled', window.scrollY > 12); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* sticky mobile buy bar on product pages */
  function initStickyBuy() {
    var bar = document.getElementById('sticky-buy');
    var anchor = document.getElementById('main-add');
    if (!bar || !anchor) return;
    var onScroll = function () {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('show', r.bottom < 0 || r.top > window.innerHeight);
    };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    var proxy = document.getElementById('sticky-add');
    if (proxy) proxy.addEventListener('click', function () {
      var btn = anchor.querySelector('button[name="add"]'); if (btn) btn.click();
    });
  }

  if (document.readyState !== 'loading') { initReveal(); initHeader(); initStickyBuy(); }
  else document.addEventListener('DOMContentLoaded', function () { initReveal(); initHeader(); initStickyBuy(); });
})();
